import React from 'react';

import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { H2 } from 'view/component/Tipografia/Texto';
import { Conteudo } from 'view/section/Conteudo/Conteudo';


export const BuscaPage: React.FunctionComponent = () => {
  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem href="/">Início</BreadcrumbItem>
        <BreadcrumbItem href="/busca">Busca</BreadcrumbItem>
        <BreadcrumbItem>Buscar por: #FIXME</BreadcrumbItem>
      </Breadcrumb>

      <Conteudo>
        <H2>Buscar por: #FIXME</H2>
        
        <p>x resultados</p>
        <ol>
          <li>asd</li>
          <li>asd</li>
          <li>asd</li>
          <li>asd</li>
          <li>asd</li>
          <li>asd</li>
          <li>asd</li>
          <li>asd</li>
          <li>asd</li>
          <li>asd</li>
          <li>PAGINAÇÃO</li>
        </ol>
      </Conteudo>
    </>
  )
}
